// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__fOnxY","title":"CardHeader_title__F8JWw"};